export const DarkTheme = {
  azulEscuro: '#0A192F', // Fundo principal (fundo da página)
  azulPrincipal: '#112240', // Fundo de containers/cards (seu Container atual)
  azulDestaque: '#233554', // Bordas e efeitos de hover
  azulAcentuado: '#3498db', // Cor viva para botões ou links importantes
  azulClaro: '#A8B2D1', // Texto secundário (parágrafos)
  azulMuitoClaro: '#CCD6F6', // Texto principal (títulos)
  brancoFrio: '#E6F1FF' // Realces e brilhos (ícones ou texto em hover)
}
